export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Decibels → linear gain. -Infinity → 0. */
export function dbToGain(db: number): number {
  return db === -Infinity ? 0 : Math.pow(10, db / 20);
}

export function gainToDb(gain: number): number {
  return gain <= 0 ? -Infinity : 20 * Math.log10(gain);
}

/** Equal-temperament frequency for a MIDI note (A4 = 69 = 440 Hz). */
export function midiToFrequency(note: number, a4Hz = 440): number {
  return a4Hz * Math.pow(2, (note - 69) / 12);
}
